import axios from 'axios';
/**
 * getEvidence get api
 * to evidence list */
export async function getEvidence(registrationId, regulationId) {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/lab_requirements?registration_id=${registrationId}&regulation_id=${regulationId}`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get evidence java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getEvidence get api
 * to evidence list */
export async function getEvidenceType(regulationId) {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/requirements?regulation_id=${regulationId}`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get evidence java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * delete evidence document post api
 * to delete evidence document  */
export async function deleteEvidenceDocument(data) {
  let result = '';
  await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/evidence_lab_document`, { data })
    .then((response) => {
      console.log('res', response);
      if (response.status === 204) {
        result = response;
      }
    })
    .catch((err) => {
      console.log('delete evidence document java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * upload evidence document api
 * to upload evidence document  */
export async function uploadDocument(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/evidence_lab_document`, data)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('check norms readiness java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * upload ocp document api
 * to upload ocp document  */
export async function uploadOcpDocument(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/evidence_ocp_document`, data)
    .then((response) => {
      result = response.data;
    })
    .catch((err) => {
      console.log('upload documents java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * get ocp documents get api
 * to evidence list */
export async function getOcpDocuments(registrationId, regulationId) {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/ocp_requirements?registration_id=${registrationId}&regulation_id=${regulationId}`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get evidence java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * delete evidence document post api
 * to delete evidence document  */
export async function deleteOcpDocument(data) {
  let result = '';
  await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/evidence_ocp_document`, { data })
    .then((response) => {
      console.log('res', response);
      if (response.status === 204) {
        result = response;
      }
    })
    .catch((err) => {
      console.log('delete evidence document java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function RequestServiceProvider(data) {
  let result = '';
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/evidences_from_service_provider`, data)
    .then((response) => {
      console.log('ress', response);
      if (response.status === 204) {
        result = response;
      }
    })
    .catch((err) => {
      console.log('check norms readiness java api error', err); // eslint-disable-line no-console
    });
  return result;
}
